import React from 'react';
import Container from '../components/Container';

function Public(props) {
  return (
    <Container>
      <h1>Public route</h1>
    </Container>
  )
}

export default Public